import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getDealsPortfolioPlans(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/partners/deal_portfolio/plans/`,
    oauthTokenHeader,
  );
}

function updateDealsPortfolioPlans(
  oauthTokenHeader: any,
  brandId: string,
  body: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/partners/deal_portfolio/plans/${brandId}/`,
    body,
    oauthTokenHeader,
  );
}

export const dealsPromotionsEndpoints = {
  getDealsPortfolioPlans,
  updateDealsPortfolioPlans,
};
